// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".Octicon-red {\n  fill: #c4202c;\n}\n", "",{"version":3,"sources":["webpack://src/components/Octicon.css"],"names":[],"mappings":"AAAA;EACE,aAAa;AACf","sourcesContent":[".Octicon-red {\n  fill: #c4202c;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
